module.exports = __webpack_public_path__ + "img/banner.49dfd1a9.jpg";